export default "__VITE_ASSET__CyTxRo9i__"